export enum LOG_TYPE {
  login,
  download_dataset,
  create_edit_model,
  delete_model,
  train_model,
  evaluate_model,
  delete_result,
  error,
  other,
}

export type LearningLogRequest = { log_type: LOG_TYPE; log: object };

export enum ACHIEVEMENT {
  DOWNLOAD_DATASET = "DOWNLOAD_DATASET",
  TRAIN_CV_MODEL = "TRAIN_CV_MODEL",
  EVALUATE_CV_MODEL = "EVALUATE_CV_MODEL",
  TRAIN_NLP_MODEL = "TRAIN_NLP_MODEL",
  EVALUATE_NLP_MODEL = "EVALUATE_NLP_MODEL",
}

export const ACHIEVEMENT_KEY: (keyof typeof ACHIEVEMENT)[] = [
  "DOWNLOAD_DATASET",
  "TRAIN_CV_MODEL",
  "EVALUATE_CV_MODEL",
  "TRAIN_NLP_MODEL",
  "EVALUATE_NLP_MODEL",
];

export interface AchievementInfo {
  name: string;
  label: string;
}

export type AchievementResponse = Record<ACHIEVEMENT, boolean>;
